import { createFileRoute } from '@tanstack/react-router';
import { GatherFactsPage } from '@/features/debrief-v2';

export const Route = createFileRoute(
  '/_dashboard/interactions/debrief-v2/$id/gather'
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  return <GatherFactsPage sessionId={id} />;
}
